import React from 'react';
import { Container, Box, Typography, Link, Divider, List, ListItem, ListItemText } from '@mui/material';
import LandingPageNav from '../../components/landingpage/LandingPageNav';
import Footer from '../../components/Footer/footer';

const SectionHeading = ({ children }) => (
  <Typography variant="h5" component="h2" sx={{ mt: 6, mb: 2, fontWeight: 700 }}>
    {children}
  </Typography>
);

export default function CaliforniaPrivacyPolicyPage() {
  return (
    <>
      <LandingPageNav />
      <Container maxWidth="md" sx={{ pt: { xs: 10, md: 12 }, pb: { xs: 6, md: 8 } }}>
        <Box>
          <Typography variant="h3" component="h1" sx={{ fontWeight: 800, mb: 3 }}>
            California Consumer Privacy Policy
          </Typography>

          <Typography variant="body1" sx={{ mb: 3 }}>
            This section supplements the information in Jet HomeLoans, LP’s privacy notice and applies solely to California residents (‘Consumer’). The California Consumer Protection Act (‘CCPA’) provides consumers with specific rights regarding their personal information. This section describes your CCPA rights and explains how to exercise those rights.
          </Typography>

          <Typography variant="body1" sx={{ mb: 3 }}>
            Under CCPA, California residents have the right to know about information collected disclosed or sold, the right to opt out of the sale of certain information, and a limited right to have businesses delete information a business has collected about the consumer. These rights extend only to California residents and information covered by CCPA. Because CCPA does not cover all consumer data in all situations, only certain consumer data subject to these rights.
          </Typography>

            <Typography variant="body1" sx={{ mb: 3 }}>
           CA-DFPI Residential Mortgage Lending Act License # 41DBO-185182
Licensed by the Department of Financial Protection and Innovation (DFPI), under the California Residential Mortgage Lending Act.
          </Typography>

          <Typography variant="body1" sx={{ mb: 3 }}>
            Information collected under the Gramm-Leach-Bliley Act (Public Law 106-102), the Fair Credit Report Act (15 U.S.C. Sec. 1681 et seq.) and the California Financial Information Act (Division 1.4, Section 4050) are exempt from CCPA.
          </Typography>

          <Typography variant="body1" sx={{ mb: 3, fontWeight: 600 }}>
            PLEASE NOTE: Any personal data collected by Jet HomeLoans, LP is in relation to a mortgage loan and is exempt from the consumer rights to know, delete and opt-out created under CCPA because this information is governed by the Gramm-Leach-Bliley Act, the Fair Credit Reporting Act, the California Financial Information Privacy Act or other state and federal laws which exempt this data from CCPA.
          </Typography>

          <SectionHeading>Information We Collect</SectionHeading>
          <Typography variant="body1" sx={{ mb: 3 }}>
            Jet HomeLoans, LP (‘Jet’) collects information that identifies, relates to, describes and references a particular consumer, known as “Personal Information”. Not all Personal Information collected is subject to CCPA. All Personal Information collected pursuant to this notice that is subject to CCPA is collected for a Business Purpose and may be shared with service providers if necessary to perform a Business Purpose. We may have collected the following categories of personal information from consumers within the last 12 months:
          </Typography>

       

          <Typography variant="body2" sx={{ mb: 4 }}>
            ** While Jet HomeLoans, LP does not sell Personal Information, Jet HomeLoans, LP may share Personal Information with its nonaffiliated insurance providers and other financial institutions so they can market to you.
          </Typography>

          <SectionHeading>Consumer Rights Under CCPA:</SectionHeading>
          <List>
            <ListItem disableGutters>
              <ListItemText
                primary="Right to Know"
                secondary="You have the right to request that Jet disclose what personal information it has collected, used, disclosed and sold over the past 12 months."
              />
            </ListItem>
            <ListItem disableGutters>
              <ListItemText
                primary="Right to Delete"
                secondary="You have the right to request that Jet delete certain personal information it has collected. However, this right does not apply where Jet needs to retain your information to comply with the law."
              />
            </ListItem>
            <ListItem disableGutters>
              <ListItemText
                primary="Right to Opt Out"
                secondary="You have the right to Opt Out of the sale of your Personal Information. Jet does not sell Personal Information for marketing purposes."
              />
            </ListItem>
            <ListItem disableGutters>
              <ListItemText
                primary="Right to Non-Discrimination"
                secondary="You have the right to not be discriminated against for having exercised your rights under CCPA."
              />
            </ListItem>
          </List>

          <Typography variant="body1" sx={{ mt: 3 }}>
            To exercise these rights, please visit us online: <Link href="https://jethl.azurewebsites.net/opt-out/" target="_blank" rel="noopener">jethl.azurewebsites.net/opt-out/</Link> or call 866-413-2563.
          </Typography>

          <Divider sx={{ my: 5 }} />
        </Box>
      </Container>
      <Footer />
    </>
  );
}
